import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Switch } from 'antd';
import { canAdministrate } from '../../utils/browser';

// Contrôlé par le formulaire (champ `admin_only`) ou par l'appelant quand il
// passe onChange (NewTemplateModal garde son état dans des useState).
const AdminOnlyFormItem = ({ checked, onChange }) => {
  const { t } = useTranslation();
  if (!canAdministrate()) return null;

  const controlled = onChange !== undefined;
  return (
    <Form.Item
      label={t('admin_only_template')}
      {...(controlled ? { htmlFor: 'admin_only' } : { name: 'admin_only', valuePropName: 'checked' })}
    >
      <Switch size='small' {...(controlled ? { id: 'admin_only', checked, onChange } : {})} />
    </Form.Item>
  );
};

export default AdminOnlyFormItem;
